import LocalStorage from '../../../helpers/localStorageHelper';
import { localStorageKeys } from '../../../constants/localStorageKeys';

export const giftAidNudgeSnoozeDays = 30;
export const giftAidNudgeSnoozeMs =
  giftAidNudgeSnoozeDays * 24 * 60 * 60 * 1000;

/**
 * Organisation id to the ISO timestamp of the dismissal. A per device
 * preference in the same spirit as the theme and favourites keys, so it is
 * deliberately not cleared on logout: being nudged again the moment you log
 * back in on the same machine would defeat the snooze.
 */
type SnoozeMap = Record<string, unknown>;

const readSnoozeMap = (): SnoozeMap => {
  const stored: unknown = LocalStorage.getItem(
    localStorageKeys.GIFT_AID_NUDGE_SNOOZE
  );
  return typeof stored === 'object' && stored !== null && !Array.isArray(stored)
    ? (stored as SnoozeMap)
    : {};
};

/** True while a dismissal for this organisation is under 30 days old. */
export const isSnoozed = (
  orgId: string | number,
  now: number = Date.now()
): boolean => {
  const dismissedAtIso = readSnoozeMap()[String(orgId)];
  if (typeof dismissedAtIso !== 'string') {
    return false;
  }
  const dismissedAt = Date.parse(dismissedAtIso);
  if (Number.isNaN(dismissedAt)) {
    return false;
  }
  // Strict, so the nudge is back on the day the 30 days are up.
  return now - dismissedAt < giftAidNudgeSnoozeMs;
};

/** Records a dismissal, keeping other organisations' entries intact. */
export const snooze = (
  orgId: string | number,
  now: number = Date.now()
): void => {
  LocalStorage.setItem(localStorageKeys.GIFT_AID_NUDGE_SNOOZE, {
    ...readSnoozeMap(),
    [String(orgId)]: new Date(now).toISOString()
  });
};
